import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { cachedSerialNames31jc5fovi62px as cachedSerialNames } from './Platform.common.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from '../descriptors/SerialDescriptor.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from './CachedNames.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var NullableSerializerClass;
function NullableSerializer() {
  if (NullableSerializerClass === VOID) {
    class $ {
      constructor(serializer) {
        this.c20_1 = serializer;
        this.d20_1 = new (SerialDescriptorForNullable())(this.c20_1.b1n());
      }
      b1n() {
        return this.d20_1;
      }
      e20(encoder, value) {
        if (!(value == null)) {
          encoder.o1t();
          encoder.l1t(this.c20_1, value);
        } else {
          encoder.o1s();
        }
      }
      c1n(encoder, value) {
        return this.e20(encoder, value);
      }
      d1n(decoder) {
        return decoder.d1r() ? decoder.r1r(this.c20_1) : decoder.e1r();
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof NullableSerializer()))
          THROW_CCE();
        if (!equals(this.c20_1, other.c20_1))
          return false;
        return true;
      }
      hashCode() {
        return hashCode(this.c20_1);
      }
    }
    initMetadataForClass($, 'NullableSerializer', VOID, VOID, [KSerializer()]);
    NullableSerializerClass = $;
  }
  return NullableSerializerClass;
}
var SerialDescriptorForNullableClass;
function SerialDescriptorForNullable() {
  if (SerialDescriptorForNullableClass === VOID) {
    class $ {
      constructor(original) {
        this.r1p_1 = original;
        this.s1p_1 = this.r1p_1.e1o() + '?';
        this.t1p_1 = cachedSerialNames(this.r1p_1);
      }
      e1o() {
        return this.s1p_1;
      }
      b1r() {
        return this.t1p_1;
      }
      q1p() {
        return true;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SerialDescriptorForNullable()))
          return false;
        if (!equals(this.r1p_1, other.r1p_1))
          return false;
        return true;
      }
      toString() {
        return toString(this.r1p_1) + '?';
      }
      hashCode() {
        return imul(hashCode(this.r1p_1), 31);
      }
      x1p() {
        return this.r1p_1.x1p();
      }
      y1p() {
        return this.r1p_1.y1p();
      }
      z1p() {
        return this.r1p_1.z1p();
      }
      a1q() {
        return this.r1p_1.a1q();
      }
      b1q(index) {
        return this.r1p_1.b1q(index);
      }
      c1q(name) {
        return this.r1p_1.c1q(name);
      }
      d1q(index) {
        return this.r1p_1.d1q(index);
      }
      e1q(index) {
        return this.r1p_1.e1q(index);
      }
      f1q(index) {
        return this.r1p_1.f1q(index);
      }
    }
    initMetadataForClass($, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    SerialDescriptorForNullableClass = $;
  }
  return SerialDescriptorForNullableClass;
}
//region block: exports
export {
  NullableSerializer as NullableSerializer41etqlj0tdq5,
  SerialDescriptorForNullable as SerialDescriptorForNullable2slcv65za9oog,
};
//endregion

//# sourceMappingURL=NullableSerializer.mjs.map
